import { ChangeEvent, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, MenuItem, TextField } from '@mui/material';

import { selectEventFormDialogPlace } from 'main/store/schedule/selectors';
import { actions } from 'main/store/schedule/reducer';
import { isPlace, PLACE_VALUES } from 'main/store/schedule/state';

const OTHERS = 'その他';

export const PlaceForm = () => {
    const dispatch = useDispatch();
    const value = useSelector(selectEventFormDialogPlace);
    const [innerPlace, setInnerPlace] = useState('');
    const [otherPlace, setOtherPlace] = useState('');

    useEffect(() => {
        setInnerPlace(isPlace(value) ? value : OTHERS);
        setOtherPlace(isPlace(value) ? '' : value);
    }, [value]);

    const handlePlaceSelectChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
        setInnerPlace(event.target.value);
        if (event.target.value !== OTHERS) {
            dispatch(actions.changeEventDialogDataPlace(event.target.value));
        }
    }, [dispatch]);

    const handleOtherPlaceChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
        setOtherPlace(event.target.value);
        dispatch(actions.changeEventDialogDataPlace(event.target.value));
    }, [dispatch]);

    return (
        <Grid container direction="row" spacing={1}>
            <Grid item xs={innerPlace !== OTHERS}>
                <TextField select label="場所" value={innerPlace} onChange={handlePlaceSelectChange} fullWidth={innerPlace !== OTHERS}>
                    {PLACE_VALUES.map(place => (
                        <MenuItem key={place} value={place}>{place}</MenuItem>
                    ))}
                    <MenuItem value={OTHERS}>その他</MenuItem>
                </TextField>
            </Grid>
            {innerPlace === OTHERS &&
                <Grid item xs>
                    <TextField value={otherPlace} onChange={handleOtherPlaceChange} />
                </Grid>
            }
        </Grid>
    )
}
